import type { SupabaseClient } from "@supabase/supabase-js";
import type { GhlNewConnectionDraft, GhlNewPipelineDraft } from "@/components/admin/ghl/ghlSectionShared";

export async function ghlDbUpdateApiKey(sb: SupabaseClient, connId: string, key: string): Promise<void> {
  const { error } = await sb.from("ghl_connections").update({ ghl_api_key: key }).eq("id", connId);
  if (error) throw error;
}

export async function ghlDbUpdateWebhook(sb: SupabaseClient, connId: string, url: string | null): Promise<void> {
  const { error } = await sb.from("ghl_connections").update({ webhook_url: url }).eq("id", connId);
  if (error) throw error;
}

export async function ghlDbInsertConnection(
  sb: SupabaseClient,
  organizationId: string,
  draft: GhlNewConnectionDraft
): Promise<void> {
  const { error } = await sb.from("ghl_connections").insert({
    organization_id: organizationId,
    company_name: draft.company_name.trim(),
    ghl_location_id: draft.ghl_location_id.trim(),
    ghl_api_key: draft.ghl_api_key.trim(),
    webhook_url: draft.webhook_url.trim() || null,
    is_active: true,
  });
  if (error) throw error;
}

export async function ghlDbInsertPipeline(
  sb: SupabaseClient,
  connectionId: string,
  draft: GhlNewPipelineDraft
): Promise<void> {
  const { error } = await sb.from("ghl_pipelines").insert({
    ghl_connection_id: connectionId,
    ghl_pipeline_id: draft.ghl_pipeline_id.trim(),
    pipeline_name: draft.pipeline_name.trim(),
    location_id: draft.location_id || null,
    product_type: draft.product_type.trim().toLowerCase() || null,
    is_active: true,
  });
  if (error) throw error;
}

export async function ghlDbSetPipelineActive(sb: SupabaseClient, pipelineId: string, isActive: boolean): Promise<void> {
  const { error } = await sb.from("ghl_pipelines").update({ is_active: isActive }).eq("id", pipelineId);
  if (error) throw error;
}

export async function ghlDbSetConnectionActive(sb: SupabaseClient, connId: string, isActive: boolean): Promise<void> {
  const { error } = await sb.from("ghl_connections").update({ is_active: isActive }).eq("id", connId);
  if (error) throw error;
}
